import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: /*#__PURE__*/_normalizeClass(['el-dropdown-link', 'nav--icon'])
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createBlock(_component_el_dropdown, null, {
    dropdown: _withCtx(() => [
      _createVNode(_component_el_dropdown_menu, null, {
        default: _withCtx(() => [
          (_ctx.isStaff && _ctx.isMobile)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_ctx.forceDesktop)
                  ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                      key: 0,
                      class: "nav-menu-item",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.switchVersion(false)))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Icon, { icon: "ic:baseline-tablet-mac" }),
                        _createElementVNode("span", null, _toDisplayString(_ctx.trans("label.mobile-version")), 1)
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_el_dropdown_item, {
                      key: 1,
                      class: "nav-menu-item",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.switchVersion(true)))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Icon, { icon: "ic:baseline-desktop-mac" }),
                        _createElementVNode("span", null, _toDisplayString(_ctx.trans("label.desktop-version")), 1)
                      ]),
                      _: 1
                    }))
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.isStaff)
            ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                key: 1,
                class: "nav-menu-item",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.routeTo('/profile')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Icon, { icon: "ic:outline-contacts" }),
                  _createElementVNode("span", null, _toDisplayString(_ctx.trans("label.profile")), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.isStaff && !_ctx.isMobile)
            ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                key: 2,
                class: "nav-menu-item",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.routeTo('/config')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Icon, { icon: "ic:baseline-settings" }),
                  _createElementVNode("span", null, _toDisplayString(_ctx.trans("label.config")), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_dropdown_item, {
            class: "nav-menu-item",
            onClick: _ctx.logout
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Icon, { icon: "ic:baseline-log-out" }),
              _createElementVNode("span", null, _toDisplayString(_ctx.trans(`label.${_ctx.isStaff ? "logout" : "back"}`)), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _createVNode(_component_Icon, { icon: "ic:baseline-person" })
      ])
    ]),
    _: 1
  }))
}